import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { PageLayout } from "../../layouts/PageLayout";
import { CardLayout } from "../../components/cards";
import { Breadcrumb } from "../../components";
import { MoveStockForm } from "../../components/stock";
import { Get_Works } from "../../actions/work";
import { StockService } from "../../services";
import { ActionButton } from "../../components/v3";
import { ItemsTable } from "../../components/purchase";
import { moveStockItemsColumns } from "./constants";
import { get_date } from "../../components/generalComponets";

export const MoveStock = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [yards, setYards] = useState([]);
  const [stockItems, setStockItems] = useState([]);
  const [details, setDetails] = useState({
    yard: "",
    project: "",
    date: get_date(Date.now(), "YYYY-MM-DD"),
  });
  const [item, setItem] = useState({
    name: "",
    quantity: "",
    price: "",
  });
  const [movableStock, setMovableStock] = useState([]);

  const projects = useSelector((state) => state.work.works.data);

  // formatting projects to compatible with inputField component
  const formattedProjects = projects.map((project) => {
    return {
      ...project,
      label: project.name,
      value: project.id,
    };
  });

  // formatting yards to compatible with inputField component
  const formattedYards = yards.map((yard) => {
    return {
      ...yard,
      label: yard.yardName,
      value: yard.id,
    };
  });

  // formatting stockItems to compatible with inputField component
  const formattedStockItems = stockItems.map((item) => {
    return {
      ...item,
      label: item.itemName,
      value: item.id,
    };
  });

  useEffect(() => {
    fetchData();

    if (location.state) {
      setDetails({
        ...details,
        yard: location.state.yardId ? location.state.yardId : "",
      });
    }
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const yards = await StockService.getYards();
    const stockItems = await StockService.getStockItems(1);
    setStockItems(stockItems);
    setYards(yards);

    dispatch(Get_Works({}, () => {}));
    setLoading(false);
  };

  const handleDetailsChange = (event) => {
    const { name, value } = event.target;
    setDetails({ ...details, [name]: value });
  };

  const handleItemChange = (event) => {
    const { name, value } = event.target;
    setItem({ ...item, [name]: value });
  };

  const handleAddItem = () => {
    setMovableStock([...movableStock, item]);
    setItem({ name: "", quantity: "", price: "" });
  };

  const rows = movableStock.map((item, index) => {
    return {
      id: index + 1,
      sl: index + 1,
      itemName: stockItems.find((stockItem) => stockItem.id === item.name).itemName, // get item name from stockItems by id
      quantity: item.quantity,
      price: item.price,
      total: item.quantity * item.price,
    };
  });

  const handleSubmit = () => {
    alert("Stock Moved Successfully");
  };
  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <CardLayout>
            <Breadcrumb title={"Move Stock"} />
          </CardLayout>
        </Col>

        <Col xl={12}>
          <MoveStockForm
            yards={formattedYards}
            projects={formattedProjects}
            items={formattedStockItems}
            details={details}
            item={item}
            onChangeDetails={handleDetailsChange}
            onChangeItem={handleItemChange}
            onSubmit={handleAddItem}
          />
        </Col>

        <Col xl={12}>
          <ItemsTable loading={loading} columnHeaders={moveStockItemsColumns} tableRows={rows} />
        </Col>

        <Col xl={12}>
          <CardLayout>
            <ActionButton buttonText="Submit" color="primary" onButtonClick={handleSubmit} />
          </CardLayout>
        </Col>
      </Row>
    </PageLayout>
  );
};
